import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component '" + name + "' was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`In these challenging times and with just 10 years to go to reach the `}<a parentName="p" {...{
        "href": "https://www.un.org/sustainabledevelopment/sustainable-development-goals/"
      }}>{`Sustainable Development Goals`}</a>{` (SDGs), 2020 ushers in a `}<a parentName="p" {...{
        "href": "https://www.un.org/sustainabledevelopment/decade-of-action/"
      }}>{`Decade of Action`}</a>{` to accelerate solutions to the world’s biggest challenges ranging from hunger and poverty to gender inequality and climate change. Multilateralism and strong partnerships like the one between WFP and the EU are critical to make the SDGs a reality within that tight timeframe.`}</p>
    <p>{`The EU’s dedication to promoting peace and security while investing in economies, creating jobs and building resilience to climate change is vital to drive the SDGs agenda forward for the benefit of millions of men, women and children across the world. WFP believes that these actions – firmly outlined among the European Commission’s priorities – lay the foundations for a world free from hunger, amplifying the impact of WFP’s life-saving and life-changing assistance. Together we can make a major contribution to achieving the SDGs – our shared vision for the future. `}</p>
    <p>{`2020 marks the 75th anniversary of the United Nations, which coincides with an unprecedented global health crisis that has deeply affected millions of people. At a time of this great disruption for the world and its most vulnerable citizens, WFP’s collaboration with the EU, the UN’s key partner, is building on its accomplishments from 2019 to help create a better future for those furthest behind. `}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      